import request from '@/utils/request'

export function login(params) {
  return request({
    url: '/login/adminLogin',
    method: 'post',
    params: params
  })
}

export function getInfo() {
  return request({
    url: '/login/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function permission(adminId) {
  return request({
    url: '/user/permission',
    method: 'post',
    data: {
      adminId
    }
  })
}

export function updateAdminPwd(params) {
  return request({
    url: '/login/updateAdminPwd',
    method: 'post',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js